import { render, staticRenderFns } from "./CmsPartialSsr.vue?vue&type=template&id=55ba39ef&scoped=true&lang=pug"
import script from "./CmsPartialSsr.vue?vue&type=script&lang=js"
export * from "./CmsPartialSsr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ba39ef",
  null
  
)

export default component.exports